export default {
  computed: {
    shouldValidate() {
      return !!Object.keys(this.validation).length;
    },
    errorFeedbackClass() {
      if (!this.shouldValidate) {
        return {};
      }
      const ERROR_CLASS_PREFIX = 'input-error-wuk-';
      const { $params, $model, ...classCandidate } = this.validation;
      return Object.assign(...Object.keys(classCandidate).map(c => ({ [`${ERROR_CLASS_PREFIX}${c}`]: !classCandidate[c] })));
    },
    inputStateClass() {
      const classObj = { filled: this.filled };

      if (!this.shouldValidate) {
        return classObj;
      }

      return Object.assign(classObj, { 'invalid-field-wuk': this.invalidField });
    },
  },
};
